import axios from '../utils/axiosConfig';
import { Category, ApiResponse, ApiListResponse } from '../types/contentManagement';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

class CategoryService {
  private baseURL = `${API_BASE_URL}/categories`;

  // Get all categories for a specific type
  async getCategoriesByType(type: 'policy' | 'library'): Promise<Category[]> {
    try {
      const response = await axios.get<ApiListResponse<Category>>(`${this.baseURL}?type=${type}`);
      
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.message || 'Failed to fetch categories');
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  }

  // Get category by ID
  async getCategoryById(id: number): Promise<Category> {
    try {
      const response = await axios.get<ApiResponse<Category>>(`${this.baseURL}/${id}`);
      
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.message || 'Failed to fetch category');
    } catch (error) {
      console.error('Error fetching category:', error);
      throw error;
    }
  }

  // Create new category
  async createCategory(categoryData: Partial<Category>): Promise<Category> {
    try {
      const response = await axios.post<ApiResponse<Category>>(this.baseURL, categoryData);
      
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.message || 'Failed to create category');
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  }

  // Update category
  async updateCategory(id: number, categoryData: Partial<Category>): Promise<Category> {
    try {
      const response = await axios.put<ApiResponse<Category>>(`${this.baseURL}/${id}`, categoryData);
      
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.message || 'Failed to update category');
    } catch (error) {
      console.error('Error updating category:', error);
      throw error;
    }
  }

  // Delete category
  async deleteCategory(id: number): Promise<void> {
    try {
      const response = await axios.delete<ApiResponse<null>>(`${this.baseURL}/${id}`);
      
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to delete category');
      }
    } catch (error) {
      console.error('Error deleting category:', error);
      throw error;
    }
  }

  // Get category color
  getCategoryColor(color: string | undefined): string {
    return color || '#95a5a6';
  }
}

export default new CategoryService();
